import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { intersection } from "lodash";

import { useGetWorkerLicensesAllowedForDocuments } from "./useGetWorkerLicensesAllowedForDocuments";
import { truncateQualifications } from "./utils/truncateQualifications";

interface UseGetRequirementApplicableQualificationsOptions {
  truncationLength?: number;
}

export function useGetQualificationsForRequirement(
  qualifications: string[],
  options: UseGetRequirementApplicableQualificationsOptions = {}
) {
  const { licenses: availableLicenses } = useGetWorkerLicensesAllowedForDocuments();
  const applicableQualifications = intersection(qualifications, availableLicenses);

  const { data: qualificationDisplayLabels, isLoading } =
    useGetQualificationDisplayLabels(applicableQualifications);
  const distinctQualificationDisplayLabels = [...new Set(qualificationDisplayLabels)];
  const truncatedQualifications = truncateQualifications(
    distinctQualificationDisplayLabels,
    options.truncationLength
  );

  return {
    applicableQualifications,
    qualificationDisplayLabels: distinctQualificationDisplayLabels,
    truncatedQualifications,
    isLoading,
  };
}
